<template>
	<div class="px-2">
		<v-scroll-y-reverse-transition>
			<div class="mb-2" v-if="p.show">
				<v-card :elevation="0" class="pa-2" v-click-outside="p.reject">
					¿Quieres cambiar de entorno?
					<v-card-actions class="pa-0 mt-4">
						<v-spacer />
						<v-btn @click="p.reject" text color="error">NO</v-btn>
						<v-btn @click="p.resolve" text color="primary">SI</v-btn>
					</v-card-actions>
				</v-card>
				<div class="triangle"></div>
			</div>
		</v-scroll-y-reverse-transition>
		<v-card
			height="75"
			:color="$vuetify.theme.dark ? '' : 'primary'"
			class="d-flex flex-column justify-center mx-auto mb-1"
			style="aspect-ratio: 1;"
			@click="cambiarEntorno"
		>
			<div class="d-flex justify-center">
				<v-icon color="white">{{
					$store.getters.getEntorno == "Luz" ? "mdi-lightning-bolt" : "mdi-fire"
				}}</v-icon>
			</div>
			<div class="text-center white--text">
				{{ $store.getters.getEntorno }}
			</div>
		</v-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			p: {
				show: false,
				resolve: null,
				reject: null,
			},
		};
	},
	methods: {
		async cambiarEntorno() {
			try {
				await new Promise((resolve, reject) => {
					this.p.show = true;
					this.p.resolve = resolve;
					this.p.reject = reject;
				});

				this.$store.dispatch("cambiarEntorno");
				this.p.show = false;
			} catch (e) {
				this.p.show = false;
				this.p.resolve = null;
				this.p.reject = null;
			}
		},
	},
};
</script>

<style scoped>
.triangle {
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;

	border-top: 10px solid white;
	margin: 0 auto;
}
</style>